/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TermsAcceptanceCommandDto } from '../models/terms-acceptance-command-dto';


/**
 * API for Terms & Conditions
 */
@Injectable({
  providedIn: 'root',
})
export class TermsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation uploadTermsHtml
   */
  static readonly UploadTermsHtmlPath = '/manage/terms/upload';

  /**
   * Upload Terms & Conditions HTML and publish as version and latest.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadTermsHtml()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadTermsHtml$Response(params: {
    version: string;
    locale?: string;
    body?: {
'file': Blob;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TermsService.UploadTermsHtmlPath, 'post');
    if (params) {
      rb.query('version', params.version, {});
      rb.query('locale', params.locale, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Upload Terms & Conditions HTML and publish as version and latest.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadTermsHtml$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadTermsHtml(params: {
    version: string;
    locale?: string;
    body?: {
'file': Blob;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.uploadTermsHtml$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation createTermsAcceptance
   */
  static readonly CreateTermsAcceptancePath = '/manage/terms/acceptances';

  /**
   * Create a terms acceptance record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTermsAcceptance()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTermsAcceptance$Response(params: {
    body: TermsAcceptanceCommandDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TermsService.CreateTermsAcceptancePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Create a terms acceptance record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTermsAcceptance$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTermsAcceptance(params: {
    body: TermsAcceptanceCommandDto
  },
  context?: HttpContext

): Observable<void> {

    return this.createTermsAcceptance$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getTerms
   */
  static readonly GetTermsPath = '/terms';

  /**
   * Get latest terms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTerms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTerms$Response(params: {
    tenant: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TermsService.GetTermsPath, 'get');
    if (params) {
      rb.query('tenant', params.tenant, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Get latest terms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTerms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTerms(params: {
    tenant: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.getTerms$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getTermsByVersion
   */
  static readonly GetTermsByVersionPath = '/terms/{version}';

  /**
   * Get terms by version.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTermsByVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTermsByVersion$Response(params: {
    version: string;
    tenant: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TermsService.GetTermsByVersionPath, 'get');
    if (params) {
      rb.path('version', params.version, {});
      rb.query('tenant', params.tenant, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Get terms by version.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTermsByVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTermsByVersion(params: {
    version: string;
    tenant: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.getTermsByVersion$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
